<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Selecione o serviço</p>

    <div class="form-panel__toggles filter-mode">
      <span>Filtrar por</span>
      <a 
        class="text-link" 
        :style="filterPerDate ? 'font-weight:700;' : 'opacity:0.6;'"
        @click="filterPerDate = true"
      >Data</a> 
      ou 
      <a 
        class="text-link" 
        :style="!filterPerDate ? 'font-weight:700;' : 'opacity:0.6;'"
        @click="filterPerDate = false"
      >Criador</a>
    </div>

    <div 
      v-if="filterPerDate" 
      class="filter-group"
    >
      <div class="form-panel__field">
        <date-picker 
          label="Data Inicial"
          dense
          :binding.sync="filter.date"
          :readOnly="false"
        />
      </div>
      <div class="form-panel__field">
        <date-picker 
          label="Data Final"
          dense
          :binding.sync="filter.date_end"
          :readOnly="false"
        />
      </div>
    </div>

    <div
      v-else 
      class="form-panel__field"
    >
      <v-autocomplete
        outlined
        dense
        label="Selecione o Criador"
        v-model="filter.person_id"
        item-text="name"
        item-value="id"
        :items="creators"
        no-data-text="Nenhum Resultado"
      ></v-autocomplete>
    </div>
    
    <div 
      class="filter-group"
      v-if="filter.date && filter.date_end || filter.person_id"
    >
      <v-text-field
        v-if="filter.service_id"
        label="Criador"
        v-model="person"
        outlined
        dense
        disabled
        class="form-panel__field"
      />
      <v-autocomplete
        label="Selecione o Serviço"
        outlined
        dense
        no-data-text="Nenhum Resultado"
        :items="computedServices"
        item-text="title"
        item-value="id"
        class="form-panel__field form-panel__field--wide"
        v-model="filter.service_id"
        @change="getPerson"
      ></v-autocomplete>
    </div>
    <div class="form-panel__actions">
      <v-btn 
        class="success"
        :disabled="!filter.service_id"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";
import helpers from "@/mixins/helpers";
export default {
  name:"ReportFilters",
  mixins: [helpers],
  props:{
    creators:Array,
    services:Array
  },
  components:{
    DatePicker
  },
  data() {
    return {
      filter:{},
      filterPerDate:true,
      person:null
    }
  },
  computed: {
    computedServices() {
      if(this.services.length && this.filter.date !== undefined && this.filter.date_end) {
        const unixStartDate = Math.round(new Date(this.filter.date).getTime() / 1000);
        const unixDateEnd = Math.round(new Date(this.filter.date_end).getTime() / 1000);
        const services_validated = this.services.filter(e => e.date !== undefined && e.date !== null);
        return services_validated .filter(e => 
        Math.round(new Date(e.date).getTime() / 1000) >= unixStartDate && 
        Math.round(new Date(e.date).getTime() / 1000) <= unixDateEnd)
        .map(service => ({...service, title: this.parseDate(service.date) + " - Serviço #" + service.code}))
      } 
      else if(this.services.length && this.filter.person_id) {
        return this.services.filter(e => e.person.id === this.filter.person_id)
        .map(service => ({...service, title: this.parseDate(service.date) + " - Serviço #" + service.code}));
      }
      else {
        return [];
      }
    },
  },
  methods: {
    getPerson(id) { 
      const person = this.computedServices.find(e => e.id === id).person.name;
      this.person = person;
    },
    submit() {
      this.$emit("submit", {service_id:this.filter.service_id});
      this.$emit("update-filter", this.filter);
    }
  },
  watch: {
    filterPerDate(val) {
      if(val) {
        delete this.filter?.person_id;
      } else {
        delete this.filter?.date;
        delete this.filter?.date_end;
      }
      delete this.filter?.service_id;
    }
  }
}
</script>

<style scoped>
/* os grupos condicionais não criam caixa própria: os campos ficam em linha no painel */
.filter-group {
  display: contents;
}
.filter-mode {
  gap: 6px;
  font-size: .9rem;
  color: var(--muted);
}
.filter-mode .text-link {
  font-weight: 600;
  cursor: pointer;
}
</style>
